module.exports = __webpack_public_path__ + "img/questionnaire-image-ru.d3b0c372.jpg";